import api from './api';

const whatsappAnalyticsService = {
  // Obtener estadísticas de hoy
  getCurrentStats: async () => {
    try {
      const response = await api.get('/api/WhatsAppAnalytics/current');
      return response.data;
    } catch (error) {
      console.error('Error al obtener estadísticas actuales de WhatsApp:', error);
      throw error;
    }
  },

  // Obtener estadísticas del mes
  getMonthlyStats: async () => {
    try {
      const response = await api.get('/api/WhatsAppAnalytics/monthly');
      return response.data;
    } catch (error) {
      console.error('Error al obtener estadísticas mensuales de WhatsApp:', error);
      throw error;
    }
  },

  // Obtener estadísticas por rango de fechas
  getRangeStats: async (startDate, endDate) => {
    try {
      const response = await api.get('/api/WhatsAppAnalytics/range', {
        params: {
          startDate,
          endDate
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error al obtener estadísticas por rango de WhatsApp:', error);
      throw error;
    }
  },

  // Obtener resumen rápido
  getSummary: async () => {
    try {
      const response = await api.get('/api/WhatsAppAnalytics/summary');
      return response.data;
    } catch (error) {
      console.error('Error al obtener resumen de WhatsApp:', error);
      throw error;
    }
  }
};

export default whatsappAnalyticsService;
